import { Component } from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { Title } from "@angular/platform-browser";
import { filter, map, mergeMap } from "rxjs/operators";
import Intercom from "@intercom/messenger-js-sdk";
import { AuthService } from "./_shared/services/auth.service";
import { environment } from "src/environments/environment";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"]
})
export class AppComponent {
	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private titleService: Title,
		private authService: AuthService
	) {
		// Grab the title from index.html
		const appTitle = this.titleService.getTitle();

		this.router.events
			.pipe(
				filter(event => event instanceof NavigationEnd),
				map(() => this.activatedRoute),
				map(route => {
					while (route.firstChild) route = route.firstChild;
					return route;
				}),
				filter(route => route.outlet === "primary"),
				mergeMap(route => route.data)
			)
			.subscribe(event => {
				if (event?.["title"]) {
					return this.titleService.setTitle(event?.["title"]);
				}
				return this.titleService.setTitle(appTitle);
			});
		if (environment.intercomEnabled) {
			this.authService.$user.subscribe(user => {
				if (user?.id) {
					Intercom({
						app_id: environment.intercomAppId,
						user_id: user.id.toString(), // IMPORTANT: Replace "user.id" with the variable you use to capture the user's ID
						name: `${user.firstName || ""} ${user.lastName || ""}`, // IMPORTANT: Replace "user.name" with the variable you use to capture the user's name
						email: user.emailId
					});
				} else {
					Intercom({
						app_id: environment.intercomAppId
					});
				}
			});
		}
	}
}
